import React from "react";

const Contact = () => {
  return (
    <section className="section">
      <h2>Contact</h2>
    </section>
  );
};

export default Contact;
